export default [
  {
    path: '/kontribusi-pengguna/upload-soal',
    name: 'kontribusi-pengguna/upload-soal',
    component: () => import('@/views/menu/kontribusi-pengguna/cooming-soon/cooming-soon.vue'),
    meta: {
      pageTitle: '',
      requireAuth: true,
    },
  },
  {
    path: '/kontribusi-pengguna/upload-ebook',
    name: 'kontribusi-pengguna/upload-ebook',
    component: () => import('@/views/menu/kontribusi-pengguna/cooming-soon/cooming-soon.vue'),
    meta: {
      pageTitle: '',
      requireAuth: true,
    },
  },
]
